import { TrainingScreenData } from './TrainingScreen'
import React, { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './MobileTrainingScreen.module.scss'
import {
  MobileBodyLarge,
  MobileButton,
  MobileHeadlineLarge,
  MobileTitleLarge,
} from '../../Typography'
import YouTube from 'react-youtube'
import { ROUTES } from '../../config/routes'

type Props = {
  data: TrainingScreenData
}

export const MobileTrainingScreen = ({ data }: Props): ReactElement => {
  const navigate = useNavigate()
  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <MobileHeadlineLarge>Training</MobileHeadlineLarge>
        <MobileBodyLarge>
          FIGHTBACK-WRESTLING ist stets auf der Suche nach neuen Talenten!
        </MobileBodyLarge>
        <MobileBodyLarge>
          Die ersten Trainingseinheiten sind unverbindlich und geben dir die Möglichkeit, deine
          ersten Schritte im Wrestling zu machen.
          <br />
          Die Neulinge bekommen die Chance, sich vorzustellen und ihre Leistung im Training zu
          präsentieren.
          <br />
          Hinterher wird in Absprache mit dem Trainerstab entschieden, ob eine Weiterführung der
          Wrestlerausbildung möglich und sinnvoll ist.
          <br />
          Dabei spielen Einstellung,Verhalten, Respekt und Leistung eine wichtige Rolle.
        </MobileBodyLarge>
        <MobileBodyLarge>
          Die Dauer der Wrestlingausbildung ist von Person zu Person höchst unterschiedlich und
          hängt nicht zuletzt von den oben genannten Punkten ab.
        </MobileBodyLarge>
        <div
          className={styles.button}
          onClick={(): void =>
            navigate(ROUTES.contact, { state: 'Ich möchte in den Ring steigen', replace: true })
          }
        >
          <MobileButton darkFont={true}>KONTAKT</MobileButton>
        </div>
      </div>
      <div className={styles.videoContainer}>
        {data.cookiesAccepted ? (
          <YouTube videoId={data.youtubeVideoId} />
        ) : (
          <div className={styles.cookieWarning}>
            <MobileBodyLarge>
              Dieses eingebettete Video kann nicht angezeigt werden, da du der Verwendung von
              Cookies und der Datenübertragung an YouTube nicht zugestimmt hast.
            </MobileBodyLarge>
            <MobileBodyLarge>
              Mit dem Klick auf den unten stehenden Text erklärst du dich einverstanden, dass
              Inhalte von YouTube geladen werden dürfen. Dabei können personenbezogene Daten an
              YouTube übermittelt werden.
            </MobileBodyLarge>
            <div onClick={data.onAcceptCookies}>
              <MobileBodyLarge className={styles.acceptCookies}>
                Cookies für YouTube akzeptieren
              </MobileBodyLarge>
            </div>
          </div>
        )}
      </div>
      <div className={styles.textContainer}>
        <MobileHeadlineLarge>Trainingsablauf</MobileHeadlineLarge>
        <MobileBodyLarge>
          Fallschule & Einsatz der Fallschule
          <br />
          {' \u2022 '} Basic Wrestling (traditionelles Mattenwrestling)
          <br />
          {' \u2022 '} klassische Wrestlingaktionen
          <br />
          {' \u2022 '} Bewegung, Gestik und Mimik eines Wrestlers
          <br />
          {' \u2022 '} Matchaufbau / Improvisation / Trainingsmatches
        </MobileBodyLarge>
        <MobileBodyLarge>
          Als Neuling bekommst du zunächst die Basis, also die Fallschule und deren Einsatz
          beigebracht. Erst wenn du diese sicher beherrschst, kann man einen Schritt weitergehen und
          mit Aktionen beginnen. Deine Sicherheit und die deines Gegners haben absolute Priorität!
        </MobileBodyLarge>
        <MobileBodyLarge>
          Am Ende einer erfolgreich verlaufenen Trainingszeit bist du in der Lage, dich als Wrestler
          zu präsentieren und mit deinem Gegner ein ansehnliches Match zu bestreiten.
        </MobileBodyLarge>
      </div>
      <div className={styles.placesContainer}>
        <div className={styles.placeBox}>
          <img src={data.factoryImageUrl} alt={'Factory Image'} />
          <div className={styles.placeDescriptionRow}>
            <div className={styles.info}>
              <MobileTitleLarge>Fightback Factory</MobileTitleLarge>
              <div>
                <MobileBodyLarge>Am Südpark 12</MobileBodyLarge>
                <MobileBodyLarge>65451 Kelsterbach</MobileBodyLarge>
              </div>
            </div>
            <div className={styles.info}>
              <MobileTitleLarge>Mo & Mi</MobileTitleLarge>
              <MobileBodyLarge>18:30 Uhr - 20:30 Uhr</MobileBodyLarge>
            </div>
          </div>
        </div>
        <div className={styles.placeBox}>
          <img src={data.sgsImageUrl} alt={'SGS Image'} />
          <div className={styles.placeDescriptionRow}>
            <div className={styles.info}>
              <MobileTitleLarge>SGS Halle</MobileTitleLarge>
              <div>
                <MobileBodyLarge>Westerbachstraße 274A</MobileBodyLarge>
                <MobileBodyLarge>65936 Frankfurt / Sossenheim</MobileBodyLarge>
              </div>
            </div>
            <div className={styles.info}>
              <MobileTitleLarge>Sonntags</MobileTitleLarge>
              <MobileBodyLarge>13:00 Uhr - 17:00 Uhr</MobileBodyLarge>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
